import http from '@/plugin/axios'
import List from '@utils/list'
const { Search, Jurisdiction, Table, Tabs, Operation } = List

const tabs = new Tabs()
  .url('/srmDeliveryAppoint/getCountList', process.env.VUE_APP_PURCHASE_API)
  .default('0')
  .name('statusName')
  .count('statusCount')
  .value('status')

const search = new Search('deliveryappointment.urgentreservation')
  .placeholder('searchPlaceholder')
  .add('receiptWareNo').select('/srmReceiptWare/getOpenReceiptWarePage')
  .lib('dateRange').prop(['startDate', 'endDate'])

const jurisdiction = new Jurisdiction()
  .lib('add').to('Myappointment.Myappointment.Add')
  .lib('delete').del('/srmDeliveryAppoint/deleteDeliveryAppoint', process.env.VUE_APP_PURCHASE_API)

function showPeriod(vm: any) {
  return vm.$page.tab !== '3' && vm.$page.tab !== '4'
}

const table = new Table('deliveryappointment.urgentreservation')
  .add('reservationNo').width(200)
  .add('urgentSign').name('urgentSignName')
  .add('status').name('appointMentStatusName')
  .add('asnNo').label('deliveryNo').width(200)
  .add('receiptWareName')
  .add('addUserName')
  .add('addUserDept')
  .add('urgentReason')
  .add('adddate').width(180)
  .add('parkingLotNo')
  .add('parkingLotRemarks')
  .add('numberPlate')
  .add('vehicleDescription')
  .add('supOfficeName')
  .add('deliveryRemarks')
  .add('appointmentDate')
  .add('period').show(showPeriod)
  .add('master')
  .add('masterPhone')
  .add('deliveryPerson')
  .add('phone')

function getData(params: any) {
  return http({
    url: '/srmDeliveryAppoint/getAppointpage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      ...params
    }
  })
}
async function recall(this: any, row: any) {
  await this.$confirm(this.$t('deliveryappointment.urgentreservation.recallConfirm'))
  await http({
    url: '/srmDeliveryAppoint/withdraw',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: row.id }
  })
  this.refresh()
}

function perfect(this: any, row: any) {
  this.$router.push({ name: 'Myappointment.Myappointment.Perfect', params: { appointUuid: row.id }})
}
async function close(this: any, row: any) {
  await this.$confirm(this.$t('deliveryappointment.urgentreservation.closeConfirm'))
  await http({
    url: '/srmDeliveryAppoint/close',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: row.id }
  })
  this.refresh()
}
const operation = new Operation('deliveryappointment.urgentreservation')
  .add('recall').disabled((row: any) => row.status !== '2').handle(recall)
  .add('perfecttext').disabled((row: any) => row.status !== '1').handle(perfect)
  .add('close').disabled((row: any) => row.status !== '1').handle(close)

export default new List()
  .api(getData)
  .tabs(tabs)
  .search(search)
  .jurisdiction(jurisdiction)
  .table(table)
  .operation((operation))
  .end()
